import React, { useState, useEffect } from "react";
import './JobDetails.scss';
import { useHeaderTitle } from "../layout/layout";
import { useParams } from "react-router-dom";
import jobApi from "../../services/jobApi";
import JobDetailsDTO from '../../dto/jobDetailsDto';
import { getWorkModeName, getPriorityName } from "../../utils/common";

export default function Details({ jobDetails }) {
    const { setHeaderTitle } = useHeaderTitle();

    useEffect(() => {
        if (jobDetails) {
            setHeaderTitle('Job List  >   ' + jobDetails?.jobTitle + '- #' + jobDetails?.jobCode);
        }
    }, [jobDetails, setHeaderTitle]);

    if (!jobDetails) return <div>Loading...</div>;

    return (
        <section className="details-holder">
            <div className="row">
                <div className="col-12 col-md-8 left-details">
                    <h5 className="mb-3">
                        Job Description
                    </h5>

                    {/* <h6>Job Summary:</h6> */}
                    <p  dangerouslySetInnerHTML={{ __html: jobDetails?.jobDescription || '' }}>
                       
                       </p>
                    {/*}
                    <p>
                        We are looking for a creative and detail-oriented UI/UX Designer to join our team. The ideal candidate will have a strong understanding of user-centered design principles, with an ability to create seamless and aesthetically pleasing digital experiences. You will collaborate with cross-functional teams, including product managers, developers, and other designers, to deliver innovative and user-friendly solutions.
                    </p>
                    <ol>
                        <li>
                            User Research & Analysis:
                            <ul>
                                <li>
                                    Conduct user research through interviews, surveys, usability testing, and analytics to understand user behavior and needs.
                                </li>
                                <li>
                                    Analyze and interpret user feedback to inform design decisions.
                                </li>

                            </ul>
                        </li>
                        <li>
                            Wireframing & Prototyping:
                            <ul>
                                <li>
                                    Create wireframes, storyboards, user flows, and site maps to communicate interaction and design ideas.
                                </li>
                                <li>
                                    Develop high-fidelity prototypes and interactive mockups for user testing and stakeholder review.
                                </li>

                            </ul>
                        </li>
                        <li>
                            Visual Design:
                            <ul>
                                <li>
                                    Design and deliver visually appealing user interfaces for web, mobile, and desktop applications, adhering to brand guidelines and accessibility standards.
                                </li>
                                <li>
                                    Ensure a cohesive look and feel across all platforms and devices.
                                </li>

                            </ul>
                        </li>
                        <li>
                            Collaboration
                            <ul>
                                <li>
                                    Work closely with product managers, developers, and marketing teams to ensure that design solutions meet business goals and technical constraints.
                                </li>
                                <li>
                                    Participate in design critiques, brainstorming sessions, and cross-team workshops.
                                </li>

                            </ul>
                        </li>
                    </ol>{*/}
                </div>
                <div className="col-12 col-md-4 right-details">
                    <h5 className="mb-3">
                        Skills
                        <hr />
                    </h5>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            No of Positions
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.numberOfPositions}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Filled Positions
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.filledPositions}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Department
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.departmentName}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Company
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.companyNames?.join(", ") || ""}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Account
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.accountName}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Employment Type
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.employmentTypeName?.join(", ") || ""}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Work Mode
                        </label>
                        <span>:</span>
                        <p className="mb-0">{getWorkModeName(jobDetails?.workMode)}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Billable
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.billability === "billable" ? "Yes" : "No"}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Experience Required
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.experienceInYears ? jobDetails.experienceInYears : 0} Years</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Educational Qualifications
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.educationalQualificationNames?.join(", ") || ""}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Primary Skills
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.skillNames?.join(", ") || ""}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Working Hours
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.workingHours}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Fulfilment Date
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.fulfillmentDate ? new Date(jobDetails?.fulfillmentDate).toLocaleDateString('en-GB') : 'N/A'}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Priority
                        </label>
                        <span>:</span>
                        <p className="mb-0">{getPriorityName(jobDetails?.priority)}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Job Owner
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.ownerNames?.join(", ") || ""}</p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Recruiter
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.recruiterNames?.join(", ") || ""}</p>
                    </div>
                    {/* <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Team
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.departmentName}</p>
                    </div> */}
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Interview Panel
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.panelUserNames?.join(", ") || ""} </p>
                    </div>
                    <div className="d-flex gap-2 align-items-center py-2 px-2 overview-nodes">
                        <label className="form-label mb-0 w-50" >

                            Approver
                        </label>
                        <span>:</span>
                        <p className="mb-0">{jobDetails?.approverNames?.join(", ") || ""}</p>
                    </div>
                </div>
            </div>

        </section>
    );
}
